import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import { useWorks } from "../contexts/WorkContext";
import "./Home.css";
import { BASEURL } from "../constants/baseUrl";
import WorkModal from "../components/WorkModal";

const Home = () => {
  const { works, fetchWorks, loading, selectWork, fetchWorkById } = useWorks();

  useEffect(() => {
    fetchWorks();
  }, []);

  // ✅ SÉCURITÉ : works est toujours un tableau
  const safeWorks = Array.isArray(works) ? works : [];

  const sortedWorks = [
    ...safeWorks
      .filter(w => w.category === "film")
      .sort((a, b) => {
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return dateB - dateA;
      }),

    ...safeWorks
      .filter(w => w.category !== "film")
      .sort((a, b) => {
        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
        return dateB - dateA;
      }),
  ];

  return (
    <div>
      <Navbar />
      <main className="main">
        {loading ? (
          <p>Chargement des projets...</p>
        ) : (
          <div className="grid">
            {sortedWorks.map((work) => {
              const isVideo = work.image_url?.toLowerCase().endsWith(".mp4");

              return (
                <div
                  key={work.id}
                  className="card"
                  onClick={() => {
                    selectWork(work);
                    fetchWorkById(work.id!);
                  }}
                >
                  {isVideo ? (
                    <video
                      src={`${BASEURL}${work.image_url}`}
                      className="image"
                      autoPlay
                      loop
                      muted
                      playsInline
                    />
                  ) : (
                    <img
                      src={`${BASEURL}${work.image_url}`}
                      alt={work.title}
                      className="image"
                    />
                  )}
                  <div className="overlay">
                    <h3 className="workTitle">{work.title}</h3>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <WorkModal />
      </main>
    </div>
  );
};

export default Home;
